import { FileParserTuple } from "../../hooks/use-file-parser";
import { FileChip } from "../file/FileChip";
import { Row } from "../ui/flex";

interface AIChatInputFileChipsProps {
  files: File[];
  tuples?: FileParserTuple[];
  onFileRemove: (file: File) => void;
}

export const AIChatInputFileChips: React.FC<AIChatInputFileChipsProps> = ({
  files,
  onFileRemove,
  tuples,
}) => {
  if (files.length === 0) {
    return null;
  }

  return (
    <Row className="flex-wrap gap-2 rounded-b-[10px] p-2">
      {files.map((file, index) => {
        const server = tuples?.find((t) => t.local === file)?.server;
        // const loading = !server || server.markdownPath === null;
        const verified = !!server && server.markdownPath !== null;

        return (
          <FileChip
            key={index}
            file={file}
            onRemove={onFileRemove}
            loading={false}
            verified={verified}
          />
        );
      })}
    </Row>
  );
};
